/**
 * logger.js
 * Standardized debug output logging for the PT React App
 * Goals: 1) Improve distinction between standard and debug (console.log) output
 *        2) Show logs that occur at the same time in activity groups
 *        3) Allow dev to collapse message sections which aren't relevant
 */

// Group console log items together if they occur around the same time
const isGrouped = true;

// Max time (ms) before starting a new logging group
const logGroupInterval = 1200;

// Nasty global - I'm not sure how to retain global state in the logger object
let lastLogTime = 0;


const logWithStyle = (style, ...args) => {
  if (typeof args[0] === 'string') {
    args[0] = "%c" + args[0];
    args.splice(1, 0, style);
  }
  console.log(...args);
}


const logger = {
  log: (...args) => {
    if (isGrouped) {
      if (Date.now() - lastLogTime > logGroupInterval) {
        console.groupEnd();
        console.group("  ---");
      }
      lastLogTime = Date.now();
    }

    logWithStyle(
      'color: RoyalBlue; font-weight: bold',
      ...args);
  },

  logNotice: (...args) => {
    logWithStyle(
      `background: CornFlowerBlue; color: White; font-weight: bold;
        padding: 0px 4px; margin-left: 12px`,
      ...args);
  },

  logNetwork: (...args) => {
    logWithStyle(
      'color: LightSeaGreen; font-weight: bold',
      ...args);
  },

  logAnalytics: (...args) => {
    logWithStyle(
      'color: DarkOrchid; font-weight: bold',
      ...args);
  },
}

export default logger;
